module.exports = new __parcel__URL__("load_text_1.9382caa1.png").toString();